"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatedAtCell = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
require("./CreatedAtCell.scss");
const className = 'reservation-list-created-at';
const CreatedAtCell = (props) => {
    const { value } = props;
    return (react_1.default.createElement("div", { className: className }, (0, moment_1.default)(value).format(dateTimeFormat_1.DATETIME_FORMAT)));
};
exports.CreatedAtCell = CreatedAtCell;
//# sourceMappingURL=CreatedAtCell.js.map